import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useId } from "react-id-generator";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { columnLayout, columnLayoutItem } from "./conlumnLayout";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";

const WeightInListPop = ({ onResolve, onSearchInfo, plantCd }) => {
  const myGrid = useRef();

  const [show, setShow] = useState(true);

  //배차지시서 검색 URL
  const SERARCH_WEIGHTINLIST_URL = "/inspection/video/searchWeightInList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_WEIGHTINLIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const auiGrid = myGrid.current;

    auiGrid.create(columnLayout, {
      ...defaultGridProps,
      // 엑스트라 행 체크박스(showRowCheckColumn=true)를 설정한 경우, 헤더 부분에 전체 선택 체크박스를 표시할지 여부를 지정합니다.
      // 기본값(default) : true.
      showRowAllCheckBox: false,

      // 엑스트라 행 체크박스 출력 여부를 지정합니다.
      // 이 속성 값이 true 이면 최좌측에 체크박스 칼럼이 생성됩니다.
      // 기본값(default) : false.
      showRowCheckColumn: false,
      enableFilter: true,
    });

    auiGrid.bind("cellDoubleClick", function (event) {
      gridCellDBClick(event.item);
    });
    handleSearch();
  }, []);

  const gridCellDBClick = (item) => {
    onResolve(item);
    onSearchInfo(item);
    setShow(false);
  };

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    const auiGrid = myGrid.current;

    const items = auiGrid.getSelectedItems()[0];
    const item = items.item;

    onResolve(item);
    onSearchInfo(item);
    setShow(false);
  };

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_WEIGHTINLIST_URL,
      params: {
        plantCd: plantCd,
      },
    });
    const auiGrid = myGrid.current;
    auiGrid.setGridData(data);
  };

  window.onresize = function () {
    // 크기가 변경되었을 때 AUIGrid.resize() 함수 호출
    const auiGrid = myGrid.current;

    if (typeof auiGrid !== "undefined") {
      auiGrid.resize();
    }
  };
  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>입차계근정보 검색</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ width: "100%" }}>
            <AUIGrid
              ref={myGrid}
              columnLayout={columnLayout}
              gridProps={{
                ...defaultGridProps,
                width: "100%",
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose(false)}>
            취소
          </Button>

          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalWeightInListPop = createModal(WeightInListPop);

export default WeightInListPop;
